export default {
  load: (buttonId) => {
    ;(function(d, src, c) {
      var t = d.scripts[d.scripts.length - 1],
        s = d.createElement('script')
      s.id = 'la_x2s6df8d'
      s.async = true
      s.src = src
      s.onload = s.onreadystatechange = function() {
        var rs = this.readyState
        if (rs && rs != 'complete' && rs != 'loaded') {
          return
        }
        c(this)
      }
      t.parentElement.insertBefore(s, t.nextSibling)
    })(document, 'https://minimart.ladesk.com/scripts/track.js', function(e) {
      if (!window.liveAgent_btn) {
        // eslint-disable-next-line
        window.liveAgent_btn = LiveAgent.createButton(buttonId, e)
      }
    })
  },
  show: () => {
    if (window.liveAgent_btn) {
      window.liveAgent_btn.buttonDiv.style.visibility = 'visible'
    }
  },
  hide: () => {
    if (window.liveAgent_btn) {
      window.liveAgent_btn.buttonDiv.style.visibility = 'hidden'
    }
  },
}
